import { SourcingSharedJobInformationStep } from 'modules/sourcing-shared/shared-steps';
import { useSourcingInternalStore } from 'modules/sourcing-internal/stores/hooks';
import { getSourcingInternalHeaderBreadcrumbs } from 'modules/sourcing-internal/utils';
import { useShallow } from 'zustand/react/shallow';

export const SourcingInternalJobInformationStep = () => {
  const {
    candidateBatch,
    onJobInformationBack,
    onJobInformationNext,
    jobInformationFormData,
    setStep
  } = useSourcingInternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      onJobInformationBack: state.onJobInformationBack,
      onJobInformationNext: state.onJobInformationNext,
      jobInformationFormData: state.jobInformationFormData,
      setStep: state.setStep
    }))
  );

  const defaultFormData = jobInformationFormData || {
    jobTitle: candidateBatch?.jobDescriptionParsed?.jobTitle || '',
    employerName: candidateBatch?.jobDescriptionParsed?.employerName || '',
    location: candidateBatch?.jobDescriptionParsed?.location || '',
    contractType: candidateBatch?.jobDescriptionParsed?.contractType || '',
    additionalContext: ''
  };

  return (
    <SourcingSharedJobInformationStep
      headerBreadcrumbs={getSourcingInternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch?.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch?.id ?? '',
        setStep
      })}
      defaultFormData={defaultFormData}
      onJobInformationBack={onJobInformationBack}
      onJobInformationNext={onJobInformationNext}
    />
  );
};
